import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { NgxMockInterceptorModule } from 'ngx-mock-interceptor';
import { environment } from 'src/environments/environment';
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    NgxMockInterceptorModule.forRoot({
      requestPaths: [
        {
          path: 'https://api.spitas.ch/api/login',
          mockPath: '/assets/mocks/login.json',
          method: 'POST',
        },
        {
          path: 'https://api.spitas.ch/api/CollectedService/2023-05-01T00%3A00%3A00/2023-05-07T23%3A59%3A59',
          mockPath: '/assets/mocks/collectedservice.json',
          method: 'GET',
        },
        {
          path: 'https://api.spitas.ch/api/customer',
          mockPath: '/assets/mocks/recent-customers.json',
          method: 'GET',
        },
        {
          path: 'https://api.spitas.ch/api/customer/all',
          mockPath: '/assets/mocks/all-customers.json',
          method: 'GET',
        },
        {
          path: 'https://api.spitas.ch/api/customer/23/2023-04-26T00%3A00%3A00',
          mockPath: '/assets/mocks/customer-withcollectedservices.json',
          method: 'GET',
        },
        {
          path: 'https://api.spitas.ch/api/customer/details/23',
          mockPath: '/assets/mocks/customer-detail.json',
          method: 'GET',
        },
        {
          path: 'https://api.spitas.ch/api/Customer/details/7',
          mockPath: '/assets/mocks/customer-detail.json',
          method: 'GET',
        },
        //
      ],
      enableMocking: environment.useBackendMock,
    }),
  ],
})
export class MockInterceptorModule {}
